import { SelectShippingStepId, SelectShippingStepType } from "../../SelectShippingStep.types";
import { selectShippingStepLabels } from "../../selectShippingStepLabels";
import { SelectCarrier } from "./SelectCarrier";

export const selectCarrierStep: SelectShippingStepType = {
  id: SelectShippingStepId.SELECT_CARRIER,
  title: selectShippingStepLabels.selectCarrier,
  component: SelectCarrier,
};
